"use client"

import { Euro } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `EuroIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const EuroIcon = component(Icon)({ as: Euro })
